'use strict';

var assert = require('assert');

/**
 * Given an object that should be a location, ensure that it has
 * valid numeric longitude & latitude properties
 *
 * @param {Object} location object with longitude and latitude values
 * @throws {AssertError} if the object is not a valid location
 * @returns {undefined} nothing
 * @private
 */
function assertLocation(location) {
  assert(typeof location.latitude === 'number' &&
    typeof location.longitude === 'number',
    'location must be an object with numeric latitude & longitude properties');
  if (location.zoom !== undefined) {
    assert(typeof location.zoom === 'number', 'zoom must be numeric');
  }
}

module.exports = assertLocation;



//////////////////
// WEBPACK FOOTER
// ./~/mapbox/lib/assert_location.js
// module id = 106
// module chunks = 0